import { Directive, ElementRef, HostListener, OnInit } from '@angular/core';

@Directive({
  selector: '[appTextareaAutoresize]'
})
export class TextareaAutoresizeDirective implements OnInit {

  constructor(private elementRef: ElementRef<HTMLTextAreaElement>) { }

  @HostListener(':input')
  public onInput() {
    this.resize();
  }

  public ngOnInit() {
    if (this.elementRef.nativeElement.scrollHeight) {
      setTimeout(() => { this.resize(); });
    }
  }

  public resize() {
    this.elementRef.nativeElement.style.height = '44px';
    this.elementRef.nativeElement.style.height = this.elementRef.nativeElement.scrollHeight + 'px';
  }
}